import  { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { collections } from '../data';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const Collections = () => {
  const [ref, isInView] = useIntersectionObserver<HTMLDivElement>({ threshold: 0.1, once: true });

  return (
    <section ref={ref} className="py-16">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-serif text-3xl text-center mb-2 section-title">Our Collections</h2>
          <p className="text-center text-gray-600">Curated designs for every occasion</p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {collections.map((collection, index) => (
            <motion.div 
              key={collection.id} 
              className="group relative overflow-hidden"
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ 
                duration: 0.6, 
                delay: index * 0.2,
                ease: "easeOut" 
              }}
            >
              <div className="relative h-96 overflow-hidden">
                <motion.img
                  src={collection.image}
                  alt={collection.name}
                  className="h-full w-full object-cover"
                  whileHover={{ scale: 1.1 }}
                  transition={{ duration: 0.7 }}
                />
                <div className="absolute inset-0 bg-black bg-opacity-30"></div>
              </div>
              <motion.div 
                className="absolute inset-0 flex flex-col items-center justify-center p-4 text-white"
                initial={{ opacity: 0 }}
                animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                transition={{ duration: 0.6, delay: 0.3 + index * 0.2 }}
              >
                <h3 className="font-serif text-2xl mb-2">{collection.name}</h3>
                <p className="text-center mb-4 max-w-xs opacity-90">{collection.description}</p>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Link 
                    to="/shop" 
                    className="inline-block border border-white hover:border-gold hover:bg-gold px-6 py-2 uppercase tracking-wide text-sm transition-colors duration-300"
                  >
                    View Collection
                  </Link>
                </motion.div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Collections;
 